import { useCartStore } from '@/store/cartStore';
import { Separator } from '../ui/separator';
import { CartItemRow } from './CartItemRow';

interface CartSummaryProps {
  deliveryOption?: 'pickup' | 'delivery';
}

export function CartSummary({ deliveryOption = 'delivery' }: CartSummaryProps) {
  const items = useCartStore(s => s.items);
  const getSubtotal = useCartStore(s => s.getSubtotal);

  const subtotal = getSubtotal();
  const deliveryFee = deliveryOption === 'pickup' ? 0 : 0;
  const total = subtotal + deliveryFee;

  return (
    <div className="space-y-3">
      {items.map(item => (
        <CartItemRow key={item.id} item={item} />
      ))}
      <Separator />
      <div className="space-y-1. 5">
        <div className="flex justify-between text-sm">
          <p className="text-sm">Subtotal</p>
          <p>₦{subtotal.toLocaleString()}</p>
        </div>
        <div className="flex justify-between text-sm">
          <p className="text-sm">Delivery Fee</p>
          {deliveryOption === 'pickup' ? (
            <p className="text-sm">₦0</p>
          ) : (
            <p className="text-sm text-muted-foreground">Not set</p>
          )}
        </div>
        <Separator />
        <div className="flex justify-between font-bold text-base">
          <p>Total</p>
          <p>₦{total.toLocaleString()}</p>
        </div>
      </div>
    </div>
  );
}
